import { IS_DEBUG } from '@common/constants/is-debug.constant';
import { consoleService } from '@common/services/console.service';

export const throwException = (message: string): void => {
    if (IS_DEBUG) {
        throw `${message}`;
    } else {
        consoleService.error('throw exception ' + message);
    }
};
